/**
 * Created by sagardesai on 13/07/18.
 */

import {API_ENDPOINT, API_ENDPOINT_V2, AUTH_HEADERS} from "../../util/constants";
import {RSAA} from "redux-api-middleware";
import * as types from "../types/index";
import {handleUnauthorizedAccess} from "../../util/utility";

export function joinBroadcast(token, api_token, broadcast_id, data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT_V2}/join/broadcast/${broadcast_id}?api_token=${api_token}`,
            method: 'POST',
            headers: {
                Accept:'application/vnd.vuepay.v2+json',...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body:JSON.stringify(data),
            types: [types.JOIN_BROADCAST_REQUEST, types.JOIN_BROADCAST_RECEIVE, {
                type: types.JOIN_BROADCAST_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}
export function joinBroadcastGuestUser(token, api_token, broadcast_id, data) {

    return {
        [RSAA]: {
            endpoint:`${API_ENDPOINT_V2}/join/broadcast/${broadcast_id}`,
            method: 'POST',
            headers: {
                Accept:'application/vnd.vuepay.v2+json',...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            
            body:JSON.stringify(data),
            types: [types.JOIN_BROADCAST_REQUEST, types.JOIN_BROADCAST_RECEIVE, {
                type: types.JOIN_BROADCAST_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetJoinBroadcast = () => ({
    type: types.RESET_JOIN_BROADCAST,
    payload: null
});

export function joinPrivateBroadcast(token, api_token, broadcast_id, data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/join/private-session/${broadcast_id}?api_token=${api_token}`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body:JSON.stringify(data),
            types: [types.JOIN_PRIVATE_BROADCAST_REQUEST, types.JOIN_PRIVATE_BROADCAST_RECEIVE, {
                type: types.JOIN_PRIVATE_BROADCAST_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetJoinPrivateBroadcast = () => ({
    type: types.RESET_JOIN_PRIVATE_BROADCAST,
    payload: null
});